// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"dG","pgSpeechBox":"dG","speech-list-box":"dH","speechListBox":"dH"};